<template>
    <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-container class="pa-0">
                    <v-row justify="space-between" dense align="center">
                        <v-col cols="auto">
                            <v-toolbar-title>
                                {{ widget.body.title }}
                            </v-toolbar-title>
                        </v-col>
                        <v-col cols="auto">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        color="green"
                                        icon
                                        small
                                        data-sentry-label="Dashboard; zamówienia opóźnione - Generuj raport"
                                        v-on="on"
                                        @click="generateOrdersProductsDelayedReport()"
                                    >
                                        <v-icon>mdi-file-excel</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eksportuj</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-container class="pa-0">
                    <OrdersProductsDelayedListDialog
                        :is-open="ordersProductsDelayedListDialog"
                        :partner="partner"
                        :orders-products-delayed="ordersProducts"
                        @close-delayed-orders-products-dialog="closeOrdersProductsDelayedListDialog"
                    />
                </v-container>
                <v-data-table
                    :headers="headers"
                    :items="sortedOrders"
                    dense
                    :mobile-breakpoint="0"
                    hide-default-footer
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.orderLocation }}
                            </td>
                            <td>
                                {{ item.toSend }}
                            </td>
                            <td class="text-right">
                                <div class="d-inline-flex">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn 
                                                v-if="item.orderLocation"
                                                icon
                                                data-sentry-label="Wyświetl szczegóły"
                                                v-on="on"
                                                @click="showOrdersProductsDelayedListDialog(item)"
                                            >
                                                <v-icon color="blue">
                                                    mdi-ballot
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Wyświetl szczegóły</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import store from '@/store'
import tooltipDelay from '@/mixins/tooltip'
import OrdersProductsDelayedListDialog from './OrdersProductsDelayedListDialog'
import { errorHandler } from '@/utils/errorHandler'
import pagination from '@/mixins/dataTablePagination'

export default {
    name: 'OrdersDelayedReport',
    components: {
        OrdersProductsDelayedListDialog
    },
    mixins: [
        tooltipDelay,
        pagination
    ],
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Nazwa',
                    value: 'orderLocation',
                    sortable: false,
                },
                {
                    text: 'Ilość',
                    value: 'toSend',
                    sortable: false,
                },
                {
                    text: 'Szczegóły',
                    value: 'details',
                    sortable: false,
                    align: 'right'
                },
            ],
            ordersProducts: [],
            partner: '',
            ordersProductsDelayedListDialog: false,
            user: {},
        }
    },
    computed: {
        sortedOrders() {
            return this.sortOrdersByLocation()
        },
        userId() {
            return this.$store.state.user.userId
        },
    },
    mounted() {
        this.$store.dispatch('administration/getUser', this.userId )
            .then(response => {
                this.user = response.data
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        showOrdersProductsDelayedListDialog(item) {
            store.dispatch('toggleMainLoader', true)
            this.pagination.itemsPerPage = 10
            this.pagination.page = 1
            this.partner = item.orderLocation
            this.$store.dispatch('dashboard/getOrdersProductsDelayed', {
                query: `?partner=${this.partner}`
            })
                .then(response => {
                    this.ordersProducts = response.data.results
                    this.ordersProductsDelayedListDialog = true
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    store.dispatch('toggleMainLoader', false)
                })
        },
        generateOrdersProductsDelayedReport() {
            store.dispatch('toggleMainLoader', true)
            this.$store.dispatch('dashboard/generateOrdersDelayedReport', {
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    store.dispatch('toggleMainLoader', false)
                })
        },
        closeOrdersProductsDelayedListDialog() {
            this.ordersProductsDelayedListDialog = false
            setTimeout(() => {
                this.ordersProducts = []
            }, 500)
        },
        sortOrdersByLocation() {
            const selectedOrder = {'Drukomat' : 1, 'WMD': 2, 'Czeskie': 3, null: 4}
            const orders = this.widget.body.content
            
            const sortedOrders = orders.sort((a, b) => selectedOrder[a.orderLocation] - selectedOrder[b.orderLocation])

            return sortedOrders
        }
    }
}
</script>
